<template>
  <div class="detail">
      <van-collapse v-model="activeNames">
      <!-- <van-button class="btnThree" @click="$router.push('/addWork')"
        ><van-icon name="add-o" style="margin-right: 6px" />添加</van-button
      > -->
      <van-collapse-item
        class="box"
        :border="false"
        title='绩效结果'
      >
        <van-cell-group>
          <van-field
            label-width="80"
            input-align="right"
            v-model="currentDate"
            label="年份"
            readonly
            @click="openPicker"
            right-icon="arrow-down"
          />
          <van-popup
            v-model="timePicker"
            round
            get-container="body"
            position="bottom"
          >
            <van-picker
              show-toolbar
              title="选择年份"
              :default-index="defaultIndex"
              :columns="columns"
              @cancel="timePicker = false"
              @confirm="confirmDate"
            />
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <van-field
            label-width="80"
            input-align="right"
            v-model="baseinfo.empNo"
            label="工号"
            readonly
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
          label-width="80"
            type="textarea"
            autosize
            rows="1"
            input-align="right"
            v-model="baseinfo.empName"
            label="姓名"
            readonly
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
          label-width="80"
            input-align="right"
            v-model="baseinfo.postId"
            label="岗位"
            readonly
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
          label-width="80"
            input-align="right"
            v-model="baseinfo.empType"
            label="人员类别"
            readonly
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            label-width="80"
            type="textarea"
            :autosize="{ maxHeight: 80, minHeight: 20 }"
            rows="1"
            input-align="right"
            v-model="baseinfo.orgPath"
            label="组织"
            readonly
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            label-width="80"
            input-align="right"
            v-model="baseinfo.parentId"
            label="上级"
            readonly
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            label-width="100"
            input-align="right"
            v-model="baseinfo.grade"
            label="最终评估等级"
            readonly
          />
        </van-cell-group>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/apis";
import { getToken } from "@/utils/cookie";
export default {
  name: "target",
  data() {
    return {
        activeNames:[0],
        currentDate:this.$route.query.time,
        baseinfo:{
            // year: this.$route.query.time,
            empNo:'',
            empName:'',
            postId:'',
            empType:'',
            orgPath:'',
            parentId:'',
            grade:'',
        },
        timePicker:false,
        columns: [], //
        defaultIndex: 0,
    };
  },
  mounted(){
      this.getList()
      this.initYear()
  },
  methods: {
    //获取年份
    initYear(){
      const lastYear = moment(new Date()).year();
      const createdate =  moment(this.$route.query.createdate).year()
      let outYear = lastYear - createdate + 1
      this.columns = [...new Array(this.$route.query.date ? 10 : outYear).keys()]
        .map((k) => {
          return `${lastYear - k}年`;
        })
        .reverse();
    },
    // 选择年份
    openPicker() {
      const currentIndex = this.columns.findIndex((item) => {
        return item === (this.currentDate || `${moment().year()}年`);
      });
      this.defaultIndex = currentIndex > -1 ? currentIndex : 0;
      this.timePicker = true;
    },
    // 回调参数: 多列：所有列选中值，所有列选中值对应的索引
    confirmDate(value) {
      const time = parseInt(value)
      this.currentDate = time;
      this.timePicker = false;
      this.getList()
    },
    //获取个人信息
    getList(){
      const time = parseInt(this.currentDate)
      api.selectSingleKpiDetail({
        empNo: this.$route.query.empNo || getToken(),
        searchYear: this.$route.query.dataPickerYearVal || time
      }).then((data)=>{
        if(!data.data.grade){
          data.data.grade = '暂无'
        }
        this.baseinfo = data.data
      })
    }
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .detail {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .detail {
    width: 276px * $zoom;
  }
}
.detail {
  font-size: 16px * $zoom;
  min-height: 100vh;
  background: #f4f5f8;
  position: relative;
  padding: 7px * $zoom 10px * $zoom;
  .van-collapse-item {
    // margin-top: 5px * $zoom;
    background: none;
  }
  ::v-deep .van-cell__title span {
    font-size: 16pt;
    border-left: 6px solid #018755;
    padding-left: 15px;
    color: #3D3D3D;
  }
  ::v-deep .van-field {
    span {
      font-size: 10px * $zoom;
      border: none;
      padding-left: 0;
    }
  }
  ::v-deep .van-cell {
    display: flex;
    justify-content: space-between;
    border-radius: 15px 15px 0 0;
  }
  ::v-deep .van-collapse-item__content {
    background: none;
    padding: 0;
  }
}
</style>
